import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-asset-status',
  template: `
    <span *ngIf="status === 'INUSE'" class="badge badge-success">InUse</span>
    <span *ngIf="status === 'DISPOSED'" class="badge badge-danger">Disposed</span>
    <span *ngIf="status === 'RETURNED_TO_SUPPLIER'" class="badge badge-danger">Returned to Supplier</span>
    <span *ngIf="status === 'PENDING_ACQUISITION'" class="badge badge-info">Pending Acquisition</span>
    <span *ngIf="status === 'NEW'" class="badge badge-success">New</span>
    <span *ngIf="status === 'WAITING_CREATE_APPROVAL'" class="badge badge-warning">Waiting Create Approval</span>
    <span *ngIf="status === 'WAITING_DELETION_APPROVAL'" class="badge badge-warning">Waiting Delete Approval</span>
    <span *ngIf="status === 'WAITING_EDIT_APPROVAL'" class="badge badge-warning">Waiting Edit Approval</span>
    <span *ngIf="status === 'EXPENSED'" class="badge badge-danger">Expensed</span>
    <span *ngIf="status === 'WAITING_DISPOSAL_APPROVAL'" class="badge badge-warning">Disposal Approval Pending</span>
    <span *ngIf="status === 'WAITING_IMPAIRMENT_APPROVAL'" class="badge badge-warning">Impairment Approval Pending</span>
    <span *ngIf="status === 'WAITING_UPGRADE_APPROVAL'" class="badge badge-warning">Upgrade Approval Pending</span>
    <span *ngIf="status === 'WAITING_REVALUATION_APPROVAL'" class="badge badge-warning">Revaluation Approval Pending</span>
    <span *ngIf="status === 'WAITING_ACQUISITION_APPROVAL'" class="badge badge-warning">Acquisition Approval Pending</span>
    <span *ngIf="status === 'WAITING_ADJUSTMENT_APPROVAL'" class="badge badge-warning">Adjustment Approval Pending</span>
    <span *ngIf="status === 'WAITING_RULCHANGE_APPROVAL'" class="badge badge-warning">Rul Change Approval Pending</span>
    <span *ngIf="status === 'WIP'" class="badge badge-success">Not Commissioned</span>
  `,
  styles: []
})
export class AssetStatusComponent implements OnInit {
  @Input() public status: string;
  constructor() {}

  ngOnInit() {}
}
